<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Global Navigation Header
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="c-global-navigation-header">
<maced-global-header globalHeaderId="globalHeader8" [title]="title"  
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [hasMenu]="true" [options]="options" [downloadBtnText] = 'downloadBtnText'
  [selectedOption]="selectedOptions">
  <ng-container ngProjectAs="[actions]">
    <ul class="c-headers__list" *ngIf="isMobileView && isBrowser">
      <li class="c-headers__list-item">
        <maced-button [buttonId]="buttonId" [ariaLabel]="buttonLable" [ariaExpanded]="isShowCascadebar"  [name]="buttonLable" [label]="buttonLable"
         size="large" color="secondary" type="button" [icon]="!isShowCascadebar? 'icon-dots-vertical': 'icon-x-close'"
        (click)="openMenu()">
      </maced-button>        
      </li>
    </ul>
  </ng-container>
  </maced-global-header>
  <ng-container *ngIf="isShowCascadebar">
    <ng-container *ngFor="let cascadeMenu of cascadeMenus;let i = index">
      <maced-cascade-menubar [cascadeMenubarId]="'CascadeMenubar' + i" [cascadeMenubarLabel]="cascadeMenu.name"
        [cascadeMenuList]="cascadeMenu.menus" (menuEvent)="onClickCascadeMenu($event,i)"
        (backEvent)="onClickCascadeBack(i)" (closeEvent)="onClickCascadeClose()"
        [hasBackButton]="i==0 ? false: true" [hasCloseButton]="false" [hasTitleBar]="i==0 ? false: true"
        *ngIf="cascadeMenu.isVisible">
      </maced-cascade-menubar>
    </ng-container>
  </ng-container>
  </div>
